module.exports = __webpack_public_path__ + "6df8ca99565b8e31b242b41f1bb025d6.png";